<button
  class="button"
  [ngClass]="{
    cancel: type === 'CANCEL',
    save: type === 'SAVE',
    delete: type === 'DELETE' || type === 'SECOND',
    withoutLabel: withoutLabel
  }"
  [disabled]="disabled || loading"
  (click)="action()">
  <ng-container *ngIf="!loading; else spinner">
    <mat-icon
      [ngStyle]="{ 'margin-left': withoutLabel ? '0' : '-4px' }"
      svgIcon="trash-icon"
      class="trash-icon"
      *ngIf="type === 'DELETE'"></mat-icon>
    <span *ngIf="!withoutLabel" class="text-trim">{{ text }}</span>
  </ng-container>
  <ng-template #spinner>
    <mat-progress-spinner
      diameter="20"
      mode="indeterminate"
      class="button-spinner"></mat-progress-spinner>
  </ng-template>
</button>
